module.exports = __webpack_public_path__ + "static/media/Kickbacklogo.4e8a3f67.png";